import { render } from "./homeTeachEvaluation.vue?vue&type=template&id=1f8d4109&scoped=true"
import script from "./homeTeachEvaluation.vue?vue&type=script&lang=js"
export * from "./homeTeachEvaluation.vue?vue&type=script&lang=js"

import "./homeTeachEvaluation.vue?vue&type=style&index=0&id=1f8d4109&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f8d4109"]])

export default __exports__